import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { financialConditionGenerationStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';
import type { ICreditOperationsTotalsProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/creditOperations/types.ts';
import { formatThousandAmount } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';

export const CreditOperationsTotals: React.FC<ICreditOperationsTotalsProps> = ({ totals }) => (
  <>
    {totals.length > 0 && (
      <TableContainer sx={financialConditionGenerationStyles.currencyTotalsTable}>
        <Table size="small" aria-label="Підсумки кредитних операцій за валютами">
          <TableHead>
            <TableRow>
              <TableCell>Валюта</TableCell>
              <TableCell align="right">Ліміт, тис. од.</TableCell>
              <TableCell align="right">Заборгованість, тис. од.</TableCell>
              <TableCell align="right">Прострочення, тис. од.</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {totals.map(({ currency, limit, outstandingDebt, overdueDebt }) => (
              <TableRow key={currency.value}>
                <TableCell>{currency.label}</TableCell>
                <TableCell align="right">{formatThousandAmount(limit)}</TableCell>
                <TableCell align="right">{formatThousandAmount(outstandingDebt)}</TableCell>
                <TableCell align="right">{formatThousandAmount(overdueDebt)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </>
);
